import type {ActiveShiftRow} from "@ots-frontend/ots-ui-tw";

export function activeShiftFocusUrl(destination: "dispatch" | "tickets", row: ActiveShiftRow, now: number): string {
  const search = new URLSearchParams({
    focusDriver: row.personId,
    focusRegion: row.regionId,
    focusName: row.driver,
    focusDate: String(now),
  });
  return `/${destination}?${search}`;
}

export function readActiveShiftFocus(search: string, regionId?: string) {
  const params = new URLSearchParams(search);
  const personId = params.get("focusDriver") || undefined;
  const date = Number(params.get("focusDate"));
  return {
    personId: params.get("focusRegion") === regionId ? personId : undefined,
    name: params.get("focusName") || "Driver",
    date: params.has("focusDate") && Number.isFinite(date) && date > 0 ? date : undefined,
  };
}

export function clearActiveShiftFocus(search: string): string {
  const params = new URLSearchParams(search);
  for (const key of ["focusDriver", "focusRegion", "focusName", "focusDate"]) params.delete(key);
  return params.toString() ? `?${params}` : "";
}
